// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__yX-J9","legacyBtn":"MutateMid_legacyBtn__LN10t"};